import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';

/**
 * Corporate shell: sticky top nav + footer. Solid backgrounds. No gradients.
 */
const AppShell = ({ children }) => {
  const location = useLocation();
  const showBackHome = location.pathname !== '/';

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]" data-testid="app-shell">
      {/* Top nav */}
      <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-10 py-4">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-home-link">
            <img
              src="/eyb-logo.png"
              alt="EYB Consulting"
              className="h-10 w-10 object-contain"
              data-testid="nav-eyb-logo"
            />
            <div className="hidden sm:block leading-tight">
              <div className="font-display text-[15px] font-semibold text-[#0A192F] tracking-tight">
                EYB Consulting
              </div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-medium">
                Business Resilience Index
              </div>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-6 text-sm">
            <a
              href="tel:0422731122"
              className="flex items-center gap-2 text-slate-600 hover:text-[#004B87] transition-colors"
              data-testid="nav-phone"
            >
              <Phone className="w-4 h-4" strokeWidth={1.75} />
              0422 731 122
            </a>
            <a
              href="mailto:info@eybconsulting.com.au"
              className="flex items-center gap-2 text-slate-600 hover:text-[#004B87] transition-colors"
              data-testid="nav-email"
            >
              <Mail className="w-4 h-4" strokeWidth={1.75} />
              info@eybconsulting.com.au
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white mt-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src="/eyb-logo.png" alt="EYB Consulting" className="h-8 w-8 object-contain opacity-80" />
            <div className="text-xs text-slate-500 leading-relaxed">
              &copy; {new Date().getFullYear()} EYB Consulting Pty Ltd. All rights reserved.
              <br />
              This tool provides indicative insights only and does not constitute financial or legal advice.
            </div>
          </div>
          <a
            href="https://eybconsulting.com.au/get-started/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs uppercase tracking-[0.2em] font-semibold text-[#004B87] hover:text-[#0A192F] transition-colors"
            data-testid="footer-get-started"
          >
            Book a Consultation &rarr;
          </a>
        </div>
      </footer>
    </div>
  );
};

export default AppShell;
